import React from "react";
import { NavLink, Link } from "react-router-dom";
import nav_logo from "../assets/nav_logo.webp";
import nav_logo_resin from "../assets/nav_logo_resin.webp";
import "../styles/navbar.css";
import { useBackground } from "../context/BackgroundContext";
import CatalogDropdowns from "./CatalogDropdowns";

function NavBar() {
  const { theme } = useBackground();

  return (
    <nav
      className="navbar sticky-top navbar-expand-lg custom-navbar"
      style={{ backgroundColor: theme.navbarBg, color: theme.text }}
    >
      <div className="container">
        <NavLink to="/" className="navbar-brand">
          <img
            src={theme.themeName === "fesishop" ? nav_logo : nav_logo_resin}
            alt="nav logo"
          />
        </NavLink>

        <button
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={{
            borderColor: theme.text,
          }}
        >
          <span
            className="navbar-toggler-icon"
            style={{
              backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='${encodeURIComponent(
                theme.text,
              )}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>")`,
            }}
          ></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav me-auto" style={{ gap: "1rem" }}>
            {/* Home */}
            <li className="nav-item">
              <NavLink
                to="/home"
                className={({ isActive }) =>
                  "nav-link" + (isActive ? " active" : "")
                }
                style={{ color: theme.text }}
              >
                Home
              </NavLink>
            </li>

            {/* <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: theme.text }}
              >
                Men Shirts
              </Link>
              <ul className="dropdown-menu">
                <li>
                  <NavLink
                    className="dropdown-item text-decoration-none"
                    to="/men-shirts"
                    style={{ color: theme.textSecondary }}
                  >
                    Men Shirts
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item text-decoration-none"
                    to="/sale/menShirt"
                    style={{ color: theme.textSecondary }}
                  >
                    Sale
                  </NavLink>
                </li>
              </ul>
            </li>

            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: theme.text }}
              >
                Women Shirts
              </Link>
              <ul className="dropdown-menu">
                <li>
                  <NavLink
                    className="dropdown-item text-decoration-none"
                    to="/women-shirts"
                    style={{ color: theme.textSecondary }}
                  >
                    Women Shirts
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item text-decoration-none"
                    to="/sale/womenShirt"
                    style={{ color: theme.textSecondary }}
                  >
                    Sale
                  </NavLink>
                </li>
              </ul>
            </li>

            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: theme.text }}
              >
                Resin Art
              </Link>
              <ul className="dropdown-menu">
                <li>
                  <NavLink
                    className="dropdown-item text-decoration-none"
                    to="/resin-art"
                    style={{ color: theme.textSecondary }}
                  >
                    Resin Art
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item text-decoration-none"
                    to="/sale/resinArt"
                    style={{ color: theme.textSecondary }}
                  >
                    Sale
                  </NavLink>
                </li>
              </ul>
            </li> */}

            {/* Texture Paint Dropdown */}
            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: theme.text }}
              >
                Texture Paint
              </Link>
              <ul className="dropdown-menu">
                <li>
                  <NavLink
                    className="dropdown-item text-decoration-none"
                    to="/texture-paint"
                    style={{ color: theme.textSecondary }}
                  >
                    Texture Paint
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item text-decoration-none"
                    to="/sale/texturePaint"
                    style={{ color: theme.textSecondary }}
                  >
                    Sale
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Catalogs */}
            <CatalogDropdowns />

            <li className="nav-item">
              <NavLink
                to="/stories"
                className={({ isActive }) =>
                  "nav-link" + (isActive ? " active" : "")
                }
                style={{ color: theme.text }}
              >
                Stories
              </NavLink>
            </li>

            {/* About */}
            <li className="nav-item">
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  "nav-link" + (isActive ? " active" : "")
                }
                style={{ color: theme.text }}
              >
                About
              </NavLink>
            </li>
          </ul>

          {/* Cart Icon */}
          <div className="d-flex align-items-center me-5">
            <NavLink
              to="/cart"
              className="nav-link"
              style={{ color: theme.text }}
            >
              <i
                className={
                  "bi" +
                  (window.location.pathname === "/cart"
                    ? " bi-cart-fill"
                    : " bi-cart")
                }
              ></i>
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
